// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"0019dc5f662f6e56adee","303":"5edd6aa17167ddcc99fa","495":"9f39366507ac418fea5d"}[chunkId] + ".js";
};